import { useEffect } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { useLocation } from 'react-router-dom';


const queryState = atom({
    key: 'searchQuery',
    default: {
        genre: '',
        area: '',
        keyword: '',
    },
});


export function useSearchQuery() {
    const query = useRecoilValue(queryState);
    const setQuery = useSetRecoilState(queryState);
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQuery({
            genre: params.get('genre') || '',
            area: params.get('area') || '',
            keyword: params.get('keyword') || '',
	});
    }, []);

    return { query, setQuery };
};
